import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { FaCircleInfo } from 'react-icons/fa6';

interface Props {
  message: string;
}

const ButtonTooltip: FC<Props> = ({ message }) => {
  const id = Math.random().toString();

  return (
    <div data-tooltip-id={id} data-tooltip-content={message}>
      <FaCircleInfo />
      <Tooltip id={id} />
    </div>
  );
};

export default ButtonTooltip;
